<template>
  <OmtLayoutHeaderFooter :bg="['none', '#F6F6F9']" :header="{ titleLabel: 'Autorizações' }">
    <router-view />
  </OmtLayoutHeaderFooter>
</template>

<script>
export default {};
</script>
